import React, { useState } from "react";
import "../Style/ForgotPassword.css"
import { forgotPassword } from "../backend";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./UserContext.js";
const ForgotPassword = () => {
  const { currentUser, setShowLoginComponent } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    const userData ={
        email,password
    }
    try{
      const res = await forgotPassword(userData);
      console.log(res)
      if(res){
          alert("Password reset successfully!");
          if(currentUser){
            navigate("/")
          }else{
            setShowLoginComponent(true);
          }
      }
    } catch(error){
        console.log(error)
        alert("Error",error);
    }
  };

  return (
    <div className="forgot-password-container">
      <form className="forgot-password-form" onSubmit={handleSubmit}>
        <h2>Forgot Password</h2>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit">Reset Password</button>
      </form>
    </div>
  );
};

export default ForgotPassword;
